<template>
    <div class="single-post">
        <header>
            <h2>{{ post.slug.replaceAll("-", " ") }}</h2>
            <div class="date">Dec 15,2025</div>
        </header>
        <div class="container">
            <div class="block">
                <strong>{{ post.title_en }}</strong>
                <p>{{ post.body_en }}</p>
                <img loading="lazy" :src="post.postImg">
            </div>
        </div>

        <br>
        <router-link to="/news" tag="button" class="txt-line">
            more news
        </router-link>
    </div>
</template>

<script>
import api from "@/apis.js";

    export default {
        data() {
            return {
                post: null,
            }
        },
        methods: {
            fetchPost() {
                if (this.$route.path.startsWith("/news/")) {
                    api.get(`/news/${this.$route.path.slice(6)}`)
                    .then(res => {
                        console.log(res.data)
                        this.post = res.data;
                    })
                    .catch(err => {
                        console.log(err);
                    })
                }
            }
        },
        mounted() {
            this.fetchPost();
        }
    }
</script>